/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Grid,
  Paper,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  InputAdornment,
  IconButton,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  ListItemText,
  Autocomplete,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import EmailIcon from '@mui/icons-material/Email';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AddIcon from '@mui/icons-material/Add';
import EnhancedEncryptionIcon from '@mui/icons-material/EnhancedEncryption';
import DeleteIcon from '@mui/icons-material/Delete';
import dayjs from 'dayjs';
import api from '../../utils/functions/api';
import TableManagementAdminEEntry from '../../components/TableManagementAdminEEntry';
import { getStorage } from '../../utils/functions/localstorage';
import Loading from '../../components/Loading';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

function ManagementAdminEEntry() {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const [isManagementAdmin, setISManagementAdmin] = useState([]);
  const roleOptions = ['Admin', 'User'];
  const [role, setRole] = useState([]);
  const [merchant, setMerchant] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [pagination, setPagination] = useState({
    currPage: 1,
    size: 10,
    lastPage: 1,
    total: 0,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [openAddManagementDialog, setOpenAddManagementDialog] = useState(false);
  const [management, setManagement] = useState({
    email: '',
  });
  const [errors, setErrors] = useState({ email: '' }); // State for error messages
  const [companyId, setCompanyId] = useState([]);

  const getUserList = async () => {
    try {
      setIsLoading(true);
      const token = getStorage('token');
      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/eentry/users?role=user,admin`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      setISManagementAdmin(data.data);
      setCompanyId(data.data[0].company_id[0]);
      setPagination((prev) => ({
        ...prev,
        total: data.data.length,
        lastPage: Math.ceil(data.data.length / pagination.size),
      }));
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error.message);
    }
  };

  useEffect(() => {
    getUserList();
  }, []);

  const getMerchants = async () => {
    try {
      const token = getStorage('token');
      const { data } = await api.get(
        `${process.env.REACT_APP_APIHOST}/eentry/merchants`,
        {
          headers: {
            Authorization: token,
          },
        },
      );
      const names = data.data.map(({ id, name }) => ({ id, name }));
      setMerchant(names);
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    getMerchants();
  }, []);

  const handleSearchTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const filteredAdminList = isManagementAdmin.filter(
    (admin) =>
      admin.username?.toLowerCase().includes(searchText.toLowerCase()) ||
      admin.email?.toLowerCase().includes(searchText.toLowerCase()),
  );

  const handlePaginationChange = (event, value) => {
    if (event === 'handleChangePage') {
      setPagination({ ...pagination, currPage: value });
    } else {
      setPagination({ ...pagination, currPage: 1, size: value });
    }
  };

  const FinalConfirmationPopup = ({ open, onClose }) => (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '15px',
          width: '400px',
        },
      }}
    >
      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '24px',
            marginTop: '20px',
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
          />
          บันทึกสำเร็จ !
        </Box>
      </DialogContent>
      <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            width: '25%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: '1px solid',
            borderRadius: '9px',
            color: '#45A6F5',
            backgroundColor: 'transparent',
            '&:hover': {
              backgroundColor: '#E3F3FF',
            },
            margin: 'auto',
          }}
        >
          <Button onClick={onClose}>Close</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );

  const [showConfirmation, setShowConfirmation] = useState(false);

  const checkField = async () => {
    let formHasErrors = false;
    const newErrors = {
      email: '',
      role: '',
      stores: '',
    };

    if (!management.email) {
      formHasErrors = true;
      newErrors.email = 'กรุณากรอกอีเมลล์';
    }

    if (!management.role) {
      formHasErrors = true;
      newErrors.role = 'กรุณาเลือกหน้าที่';
    }

    if (!management.stores || management.stores.length === 0) {
      formHasErrors = true;
      newErrors.stores = 'กรุณาเลือกร้านค้าอย่างน้อย 1 ร้าน';
    }

    setErrors(newErrors);
    return !formHasErrors;
  };

  const resetFormData = () => {
    setManagement({
      email: '',
    });
    setErrors({ email: '' }); // Reset errors
  };

  const handleCloseAddManagementDialog = () => {
    resetFormData();
    setOpenAddManagementDialog(false);
  };

  const handleAdd = async () => {
    setIsLoading(true);
    const isValid = await checkField();
    if (!isValid) {
      setIsLoading(false);
      return;
    }

    try {
      const payload = {
        email: management.email,
        createBy: getStorage('username'),
        role: management.role,
        company_ids: management.stores.map((store) => store.id),
        // store_ids: management.stores.map((store) => store.id),
      };

      const { data } = await api.post(
        `${process.env.REACT_APP_APIHOST}/eentry/users`,
        payload,
        {
          headers: { Authorization: getStorage('token') },
        },
      );

      if (data.status === 'success') {
        setShowConfirmation(true);
        resetFormData();
        handleCloseAddManagementDialog();
      }
    } catch (error) {
      console.error('Failed to add user:', error);
      alert('เกิดข้อผิดพลาดระหว่างเพิ่มผู้ใช้ กรุณาลองใหม่');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const renderFilterFormManagementAdmin = () => (
    <form>
      <Grid
        container
        alignItems="center"
        spacing={2}
        style={{ marginTop: '20px' }}
        justifyContent="space-between"
      >
        <Grid item xs={7} sm={8}>
          <TextField
            className="text"
            label="ค้นหาข้อความ :"
            variant="outlined"
            size="small"
            value={searchText}
            onChange={handleSearchTextChange}
            style={{ marginRight: '20px' }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ marginLeft: '20px' }}
          />
        </Grid>
        <Grid item xs={5} sm={4} container justifyContent="flex-end">
          <Button
            onClick={() => {
              setOpenAddManagementDialog(true);
            }}
            variant="contained"
            color="primary"
            size="medium"
            style={{ marginRight: '20px' }}
            startIcon={<PersonAddIcon />}
          >
            เพิ่มบัญชี
          </Button>
        </Grid>
      </Grid>

      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </form>
  );

  return (
    <Grid container>
      <Loading isLoading={isLoading} />
      <Grid item xs={12} md={12}>
        <div className="font-bold text-xl" style={{ marginLeft: '20px' }}>
          Admin
        </div>
      </Grid>
      <Grid item xs={12} md={12}>
        {renderFilterFormManagementAdmin()}
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper
          sx={{
            overflow: 'hidden',
            marginTop: '20px',
            marginLeft: { xs: '10px', sm: '15px', md: '20px' },
            marginRight: { xs: '10px', sm: '15px', md: '20px' },
          }}
        >
          <TableManagementAdminEEntry
            merchant={merchant}
            isManagementAdmin={filteredAdminList}
            pagination={pagination}
            handlePaginationChange={handlePaginationChange}
          />
        </Paper>
      </Grid>

      <Dialog
        open={openAddManagementDialog}
        onClose={handleCloseAddManagementDialog}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '550px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginRight: '10px',
              marginLeft: '10px',
              marginTop: '6px',
            }}
          >
            <span>เพิ่มบัญชี</span>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px',
              marginTop: '15px',
            }}
          >
            <EmailIcon sx={{ marginRight: '20px' }} />
            <TextField
              label="อีเมลล์"
              variant="outlined"
              size="small"
              sx={{ width: '380px' }}
              value={management.email}
              onChange={(e) =>
                setManagement((prev) => ({
                  ...prev,
                  email: e.target.value,
                }))
              }
              error={!!errors.email}
              helperText={errors.email}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px',
            }}
          >
            <StorefrontIcon sx={{ marginRight: '20px' }} />
            <Autocomplete
              multiple
              options={merchant}
              disableCloseOnSelect
              getOptionLabel={(option) => option.name} // ดึงแค่ name มาแสดง
              value={management.stores || []}
              onChange={(event, newValue) =>
                setManagement((prev) => ({
                  ...prev,
                  stores: newValue,
                }))
              }
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option.name} {/* แสดงเฉพาะ name */}
                </li>
              )}
              style={{ width: 380 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="ร้านค้า"
                  placeholder="เลือกหรือพิมพ์ค้นหา"
                  size="small"
                  error={!!errors.stores}
                  helperText={errors.stores}
                />
              )}
              filterSelectedOptions
            />
          </Box>

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px',
            }}
          >
            <PeopleAltIcon sx={{ marginRight: '20px' }} />
            <FormControl
              sx={{ width: '380px' }}
              size="small"
              error={!!errors.role}
            >
              <InputLabel>หน้าที่</InputLabel>
              <Select
                value={management.role || ''}
                onChange={(e) =>
                  setManagement((prev) => ({
                    ...prev,
                    role: e.target.value,
                  }))
                }
                label="หน้าที่"
              >
                {roleOptions.map((role) => (
                  <MenuItem key={role} value={role}>
                    {role}
                  </MenuItem>
                ))}
              </Select>
              {errors.role && <FormHelperText>{errors.role}</FormHelperText>}
            </FormControl>
          </Box>
        </DialogContent>

        <DialogActions sx={{ marginBottom: '20px', marginRight: '20px' }}>
          <Button
            onClick={handleCloseAddManagementDialog}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(252, 58, 58, 0.1)',
              },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleAdd}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': {
                backgroundColor: 'rgba(81, 210, 69, 0.1)',
              },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}

export default ManagementAdminEEntry;
